export const servicProviderTypes = '/service-provider-types';
export const servicProviderType = (id: number) => `/service-provider-types/${id}`;
